import { ScissorOutlined, CommentOutlined, StopOutlined } from "@ant-design/icons"
import { Popover, Tag, Typography, Tooltip } from "antd"
import React from "react"

const { Text } = Typography

export const OrderAndPrefix = (record, onStopClick) => {
  // 1. Gather comments if available
  const commentLines = []
  if (record.salesComment) {
    commentLines.push(`Sales: ${record.salesComment}`)
  }
  if (record.designerComment) {
    commentLines.push(`Designer: ${record.designerComment}`)
  }
  if (record.PMComment) {
    commentLines.push(`PM: ${record.PMComment}`)
  }

  // 2. Check if any comment lines exist
  const hasComments = commentLines.length > 0

  // 3. Build the popover content if we have comments
  const commentPopoverContent = (
    <div>
      {commentLines.map((line, index) => (
        <div key={index}>{line}</div>
      ))}
    </div>
  )

  // 4. We’ll define a small helper that returns the Comment icon if comments exist
  const CommentsIcon = () =>
    hasComments ? (
      <Popover content={commentPopoverContent}>
        <CommentOutlined style={{ marginLeft: 2, color: "#fa8c16", cursor: "pointer" }} />
      </Popover>
    ) : null

  // 5. Return your existing UI logic, adding <CommentsIcon /> at the end

  // CASE A: Split order
  if (record.splitOrder) {
    return (
      <>
        <Tag color="#fa541c">
          {record.orderNumberPrefix + record.justOrderNumber} - {record.partOfSplit} /{" "}
          {record.totalParts}
        </Tag>
        {record.newJob && (
          <Tag color="#fa541c" style={{ marginLeft: 2 }}>
            NEW
          </Tag>
        )}
        {record.complaintStatus === "In review" && (
          <Tag color="gold" style={{ marginLeft: 2 }}>
            REVIEW
          </Tag>
        )}
        <CommentsIcon />
      </>
    )
  }

  // CASE B: Stop requested
  else if (record.requestedToStop) {
    return (
      <>
        <Tag color="green">{record.orderNumberPrefix + record.justOrderNumber}</Tag>
        <Tooltip title="Stop requested? - Click to view details">
          <StopOutlined
            style={{ color: "red", fontSize: "16px", cursor: "pointer" }}
            onClick={() => onStopClick && onStopClick(record)}
          />
        </Tooltip>
        {record.newJob && (
          <Tag color="#fa541c" style={{ marginLeft: 2 }}>
            NEW
          </Tag>
        )}
        {record.complaintStatus === "In review" && (
          <Tag color="gold" style={{ marginLeft: 2 }}>
            REVIEW
          </Tag>
        )}
        <CommentsIcon />
      </>
    )
  }

  // CASE C: Normal order
  else {
    return (
      <>
        <Tag color="green">{record.orderNumberPrefix + record.justOrderNumber}</Tag>
        <Popover content={"From cutter"}>
          {record.originalMachine ? (
            <ScissorOutlined style={{ color: "#f5222d", marginLeft: 2 }} />
          ) : null}
        </Popover>
        {record.newJob && (
          <Tag color="#fa541c" style={{ marginLeft: 2 }}>
            NEW
          </Tag>
        )}
        {record.complaintStatus === "In review" && (
          <Tag color="gold" style={{ marginLeft: 2 }}>
            REVIEW
          </Tag>
        )}
        <CommentsIcon />
      </>
    )
  }
}

// Unchanged
export const ASAPOrder = (record) => {
  if (record.priorityOrder) {
    return <Text style={{ color: "#fa541c" }}>ASAP!</Text>
  } else {
    return null
  }
}
